<script setup lang="ts">
import { useSubscriptionRequiredModal } from '~/composables/useSubscriptionRequiredModal';

const open = defineModel<boolean>({ default: false });
const subscriptionRequiredModal = useSubscriptionRequiredModal();
const isNative = useIsNativePlatform();
</script>
<template>
  <UModal
    v-model:open="open"
    :ui="{
      overlay: 'z-[70]',
      content: 'z-[80]',
    }"
  >
    <template #header>
      <h2 class="text-xl font-bold">{{ $t('subscriptionRequiredModal.title') }}</h2>
    </template>

    <template #body>
      <p v-if="subscriptionRequiredModal.messageKey">{{ $t(subscriptionRequiredModal.messageKey) }}<br /><br /></p>
      <template v-if="isNative">
        {{ $t('native.shop.subscriptionRequired') }}
      </template>
      <i18n-t v-else keypath="subscriptionRequiredModal.general" tag="p">
        <template #link>
          <AppLink :to="`/shop?highlight=${subscriptionRequiredModal.productType}`">{{ $t('shop') }}</AppLink>
        </template>
      </i18n-t>
    </template>

    <template #footer>
      <div class="flex sm:justify-between w-full">
        <UButton variant="outline" color="neutral" :label="$t('button.close')" @click="subscriptionRequiredModal.show = false" />
        <UButton
          v-if="!isNative"
          variant="solid"
          :to="`/shop?highlight=${subscriptionRequiredModal.productType}`"
          :label="$t('button.toShop')"
          @click="subscriptionRequiredModal.show = false"
        />
      </div>
    </template>
  </UModal>
</template>
